<template>
    <ContentBase>
        <div style="text-align: center;">
            <el-col>
                <el-result icon="error" title="405" subTitle="您无权访问该页面">
                </el-result>
            </el-col>
        </div>
    </ContentBase>
</template>

<script>
import ContentBase from '@/components/base/ContentBase';

export default {
    // 存放templates中用到的其他组件
    components: {
        ContentBase
    }
}
</script>

<style scoped>
</style>